export default "__VITE_ASSET__Bvi4wQoR__"